import React from "react";
import { Multiselect } from "react-widgets";

const SearchAndSelectMultiple = ({
  name,
  label,
  value,
  onChange,
  disabled,
  error,
  options,
  dataKey = "_id",
  textField = "name",
}) => {
  return (
    <div className="form-group mb-3">
      <label className="d-none d-print-inline">
        <span className="d-block mb-2">{label}</span>
        <span className="d-block">{value}</span>
      </label>
      <div className="d-print-none">
        <label htmlFor={name} className="form-label">
          {label}
        </label>
        <Multiselect
          name={name}
          data={options}
          dataKey={dataKey}
          textField={textField}
          value={value}
          onChange={(items) => {
            const e = {
              currentTarget: {
                name: name,
                type: "multi",
                value: JSON.stringify(items.map((item) => item._id)),
              },
            };
            onChange(e);
          }}
          disabled={disabled}
          containerClassName="border-secondary"
        />
      </div>
      {error && <div className="alert alert-danger mt-2">{error}</div>}
    </div>
  );
};

export default SearchAndSelectMultiple;
